import React from "react";
import ProjectCard from "./ProjectCard";

const Projects = () => {
  return (
    <section id="projects" className="py-10 md:py-20 bg-gray-800 text-white">
      <div className="container mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-10">
          Alguns de Nossos Projetos
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10">
          <ProjectCard
            title="MobiUniconn"
            description="Sistema de rastreamento GPS e gestão financeira completo, com controle de estoque, rastreadores e veículos. Personalize com sua logomarca."
            image="https://images.pexels.com/photos/7362886/pexels-photo-7362886.jpeg"
            delay="100"
          />
          <ProjectCard
            title="AppChat"
            description="Com Appchat, você melhora a eficiência, centraliza as comunicações e oferece um atendimento rápido e personalizado aos seus clientes."
            image="https://images.pexels.com/photos/3153201/pexels-photo-3153201.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            delay="200"
          />
          <ProjectCard
            title="HelpTech"
            description="Aplicativo de acionamento a prestadores de serviços proximos, chaveiros, guinchos, mecânicos, eletricista, e muito mais ."
            image="https://images.pexels.com/photos/5835580/pexels-photo-5835580.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            delay="300"
          />
          <ProjectCard
            title="FloxShop"
            description="Transforme sua experiência de compra online com velocidade e segurança. FloxShop oferece uma plataforma intuitiva e confiável para suas compras."
            image="https://images.pexels.com/photos/230544/pexels-photo-230544.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" // Substitua com uma imagem relevante
            delay="400"
          />

          <ProjectCard
            title="MenuClick"
            description="Experiência completa de cardápio digital, onde seus clientes podem visualizar produtos, personalizar pedidos e realizar compras diretamente online com facilidade."
            image="https://images.pexels.com/photos/8804990/pexels-photo-8804990.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            delay="300"
          />

          <ProjectCard
            title="SapIA"
            description="SapIA é um sistema completo para preparação de concursos públicos e provas classificatórias, com material didático, simulados e acompanhamento de desempenho."
            image="https://images.pexels.com/photos/68761/pexels-photo-68761.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            delay="300"
          />
        </div>
      </div>
    </section>
  );
};

export default Projects;
